// @ts-nocheck

import { createPortal } from 'react-dom';
import { useState, useEffect } from 'react';
import _ from 'lodash';

interface IPortalProps {
  children: any;
  portalRoot: HTMLElement | null;
  closeAllComments: () => void;
}

const Portal = ({ children, portalRoot, closeAllComments }: IPortalProps) => {
  const [containerEl] = useState(() => {
    const el = document.createElement('div');
    el.style.cssText = 'position: absolute; top: 0; left:0;';
    return el;
  });
  const [root, setRoot] = useState<HTMLElement | null>(null);

  useEffect(() => {
    function closeAllCommentsForDoc(e: any) {
      const path = _.get(e, 'path') || (e.composedPath && e.composedPath());
      if (path) {
        const clickCameFromFeebackElement = path.find(elm =>
          _.includes(_.get(elm, 'attributes.class.value', ''), 'feedback'),
        );
        if (!clickCameFromFeebackElement) {
          closeAllComments();
        }
      }
    }

    if (!portalRoot) {
      // Cleanup if portalRoot becomes null
      if (containerEl.parentNode) {
        containerEl.parentNode.removeChild(containerEl);
      }
      setRoot(null);
      return;
    }

    // Attach containerEl to portalRoot if needed
    if (containerEl.parentNode !== portalRoot) {
      if (containerEl.parentNode) {
        containerEl.parentNode.removeChild(containerEl);
      }
      portalRoot.appendChild(containerEl);
    }

    setRoot(portalRoot);

    // Always add the listener with current closeAllComments
    portalRoot.addEventListener('click', closeAllCommentsForDoc);

    // Cleanup: remove listener before next effect run or on unmount
    return () => {
      portalRoot.removeEventListener('click', closeAllCommentsForDoc);
    };
  }, [containerEl, portalRoot, closeAllComments]);

  // Don't render portal if root is not set or portalRoot is null
  if (!root || !portalRoot) {
    return null;
  }
  // Ensure containerEl is actually attached to the portalRoot before rendering
  if (containerEl.parentNode !== portalRoot) {
    return null;
  }
  return createPortal(children, containerEl);
};

export default Portal;
